import { Component, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { isDisneyPlusActive, isDisneyPlusNotEligible, isOptionActive } from '@dch/products-business-logic';


import {
  EnvironmentService,
  TranslationService
} from "@proximus/ng-common";

import { OptionDetailsBackgroundService } from '../../option-details-background.service';
import { OrderButtonType } from '../../disney-plus-order-button/disney-plus-order-button.component';
import { Subscription } from 'rxjs';
import { getAlertKey } from 'src/app/shared/order-utils/order-utils';

@Component({
  selector: 'mprd-disney-plus-standard-premium',
  templateUrl: './disney-plus-standard-premium.component.html',
})
export class DisneyPlusStandardPremiumComponent
  implements OnChanges ,OnInit{

  public OrderButtonType = OrderButtonType;

  public isSubscriptionActive: boolean;
  public isPlanActive: boolean;
  public isPlanEligible: boolean;
  public isPremiumPlan: boolean;
  public isStandardPlan: boolean;
  public shouldActivatePlan: boolean;
  public isDisneyPlusProduct: boolean;
  public isPickXDisneyPlusProduct: boolean;

  public address: any;
  public alertKey: string;
  public netflixAlertKey: string;
  private registerOptionParamsExecutedSubscription: Subscription;

  constructor(
    translationService: TranslationService,
    private optionDetailsBackgroundService: OptionDetailsBackgroundService,
    protected environmentService: EnvironmentService
  ) {
    // Guarantees that the option params are set here from OptionDetailsBackgroundService whithout using inputs
    this.registerOptionParamsExecutedSubscription = this.optionDetailsBackgroundService.registerOptionParamsExecutedSubject.subscribe(() => {
      this.initializeOptionParams();
    });
    if(this.environmentService.isSmoothAccess){
      this.initializeOptionParams();
    }


  }
  isSmoothAccess = this.environmentService.isSmoothAccess;

  ngOnInit(): void {
      this.initializeOptionParams();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['option']) {
      this.initializeOptionParams();
    }
  }

  private initializeOptionParams() {
    const { option, selectedProduct } = this.optionDetailsBackgroundService.getOptionParams();

    this.initializeSubscriptionStatus(option);
    this.address = selectedProduct?.installationAddress;
    this.isDisneyPlusProduct = this.optionDetailsBackgroundService.isDisneyPlusProduct();
    this.isPickXDisneyPlusProduct = this.optionDetailsBackgroundService.isPickXDisneyPlusProduct();

    this.alertKey = getAlertKey(undefined, option);
    this.netflixAlertKey = option?.optionCodeForDescription + 'netflixAccountManagementAlertLevel3';
  }

  private initializeSubscriptionStatus(option: any) {
    if (!option) {
      return;
    }
    this.isSubscriptionActive = isOptionActive(option);
    this.isPlanActive = isDisneyPlusActive(option);
    this.isPlanEligible = !isDisneyPlusNotEligible(option);
    this.isStandardPlan = !option.isDisneyPremium;
    this.isPremiumPlan = option.isDisneyPremium;
    this.shouldActivatePlan = this.isSubscriptionActive && !this.isPlanActive;
  }
}
